import { create } from "zustand";
import { getDefaultGameState } from "../utils/game";
import { GameState } from "../types/game";

export const createDefaultGameState = (): GameState => getDefaultGameState();

interface GameStore extends GameState {
  resetGame: () => void;
  patchGame: (patch: Partial<GameState>) => void;
}

export const useGameStore = create<GameStore>((set) => ({
  ...createDefaultGameState(),

  resetGame: () => set(createDefaultGameState()),

  patchGame: (patch) =>
    set((state) => ({
      ...state,
      ...patch,
    })),
}));
